import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBCardTitle,
    MDBCol,
    MDBDatatable,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBAlert,
    MDBInput
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";
import { useNavigate } from "react-router";
import Toast from "../../components/Toast";
import { isMobile } from 'react-device-detect';
import {
    getAdminById,
    logEvent,
    saveAdmin,
} from "../../services/classApiServices.js";
// import { logEvent } from "../services/apiServices.js";
// import {
//     isEmpty,
//     isLength,
//     isValidAge,
//     isValidPhoneNumber,

// } from "../validators/helper.js";
import {
    isEmpty,
    isLength,
    isValidAge,
    isValidPhoneNumber,

} from "../../validators/helper.js";
import SideNavClass from "./SideNavClass";
// import PageError from "./PageError";
// import addImg from "./../components/images/add.svg";
// import Popup from "../components/Popup";
// import AddGym from "./AddGym";
// import logo from "./../components/images/Easy-MembrLogo.png";
import { format, parseISO } from "date-fns";
import { formatDate, formatDateTimeWithTZ } from "../../utils/DateFormat";
import { getAllPricingPlans, getSubscriptionPlans } from "../../services/apiServices";
import ExcelExportButton from "../../components/exportToExcel";
import { useAnalytics } from "../../hooks/useAnalytics";

const ClassSettings = () => {
    const { trackButtonClick } = useAnalytics();
    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [error, setError] = useState({});
    const [form, setForm] = useState({
        firstname: "",
        lastname: "",
        age: "",
        gender: "",
        number: "",
    });
    const [PlansData, setPlansData] = useState([]);
    const navigate = useNavigate();
    const [smessage, setSMessage] = useState(null);
    const [apiError, setApiError] = useState(false);
    const [basicData, setBasicData] = useState({
        columns: [
            "S.no",
            "Date",
            "Plan",
            // "Module",
            "Duration",
            "Start Date",
            "End Date",
            "Amount",
        ],
        rows: [],
    });
    const [subPlans, setSubPlans] = useState([]);
    const [activeSubPlan, setActiveSubPlan] = useState(null);
    const [showBusinessPop, setShowBusinessPop] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [Error2, setError2] = useState("")
    const [email, setEmail] = useState()
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [mdata, setMdata] = useState("")
    const [showModel, setShowModel] = useState(false)
    console.log("333333333333333333", showModel)
    const [selectedGym, setSelectedGym] = useState("")
    console.log(selectedGym)
    const [refresh, setRefresh] = useState(false)
    const maskedEmail = email ? `${email.slice(0, 4)}***@gmail.com` : "";


    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }


    useEffect(() => {
        async function fetchData() {
            const response = await getAllPricingPlans();
            if (!response || response == "false") {
                return;
            }
            let recinfo = await response.json();
            if (recinfo) {
                setPlansData(recinfo);
            }
        }
        fetchData();
        fetchPData();
        fetchAdminData();
    }, [refresh]);

    //   const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null


    //   const fetchMData = async () => {
    //     try {
    //       const updates = {
    //         gymid: gymid,
    //       };

    //       const response = await getmultigyms(updates);

    //       if (!response.ok) {
    //         throw new Error(`Error: ${response.status} - ${response.statusText}`);
    //       }

    //       const data = await response.json();
    //       setMdata(data);  // Update the state with the new data
    //     } catch (error) {
    //       console.error("Failed to fetch data:", error.message);
    //     }
    //   };

    //   useEffect(() => {
    //     if (localStorage.getItem("loggedUserInfo")) {
    //       fetchMData();
    //     }
    //   }, [gymid]);  // This runs when gymid changes




    async function fetchPData() {
        if (localStorage.getItem("loggedUserInfo")) {
            const response = await getSubscriptionPlans(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            );
            if (!response) {
                return;
            }
            if (response === "false") {
                setApiError(true);
            } else {
                const record = await response.json();
                if (!record) {
                    navigate("/");
                    return;
                }
                console.log(record);
                setSubPlans(record);
                if (record.length > 0) {
                    setActiveSubPlan(record[0]);
                }
            }
        }
    }




    // fetchPData();
    async function fetchAdminData() {
        if (localStorage.getItem("loggedUserInfo")) {
            const response = await getAdminById(
                JSON.parse(localStorage.getItem("loggedUserInfo"))._id
            );
            if (!response) {
                return;
            }
            if (response === "false") {
                setApiError(true);
            } else {
                const record = await response.json();
                if (!record) {
                    navigate("/");
                    return;
                }
                if (localStorage.getItem("setting_save")) {
                    setSMessage(localStorage.getItem("setting_save"));
                    setTimeout(() => {
                        setSMessage(null);
                        localStorage.removeItem("setting_save");
                    }, 5000);
                }
                setForm(record);
                if (!record.gender) {
                    updateForm({ gender: "Male" });
                }
            }
            setRefresh(false)
        } else {
            navigate("/login");
        }
    }


    const isAlphabetical = (str) => /^[a-zA-Z\s]+$/.test(str.trim());

    let validateForm = (e) => {
        console.log("Validating form...");
        let errors = {};
        if (isEmpty(form.firstname)) {
            errors.firstname = "First Name can't be blank";
        } else if (!isAlphabetical(form.firstname)) {
            errors.firstname = `Name allows only alphabetical characters`;
        }
        if (isEmpty(form.lastname)) {
            errors.lastname = "Last can't be blank";
        } else if (!isAlphabetical(form.lastname)) {
            errors.lastname = `Name allows only alphabetical characters`;
        }

        // if (isEmpty(form.age)) {
        //   errors.age = "Age can't be blank";
        // } else if (!isLength(form.age, { gte: 1, lte: 3, trim: true })) {
        //   errors.age = "Age must be between 15 and 100";
        // } else if (!isValidAge(form.age)) {
        //   errors.age = "Please enter valid Age";
        // }

        if (isEmpty(form.number)) {
            errors.number = "Number can't be blank";
        } else if (!isValidPhoneNumber(form.number)) {
            errors.number = "Please enter valid Contact Number";
        }

        console.log(errors);
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };


    function updateForm(value) {
        return setForm((prev) => {
            return { ...prev, ...value };
        });
    }


    // function handleOtp(value) {
    //   setOtp((prev) => ({ ...prev, ...value }));
    // }


    function processCancel() {
        // window.location.href = "/settingview";
        setBasicModal(false)
        setRefresh(true)
    }
    async function onSubmit(e) {

        const loggedUserInfo = localStorage.getItem("loggedUserInfo")
            ? JSON.parse(localStorage.getItem("loggedUserInfo"))
            : {};
        e.preventDefault();
        const updates = {
            fname: form.firstname,
            lname: form.lastname,
            age: form.age,
            gender: form.gender,
            number: form.number,
            _id: loggedUserInfo._id || "",
        };
        console.log(updates);
        let errors = validateForm(e);
        if (errors === true) {
            let saverep = await saveAdmin(
                updates,
                localStorage.getItem("loggedUserInfo")
                    ? JSON.parse(localStorage.getItem("loggedUserInfo"))._id
                    : ""
            );
            localStorage.setItem("setting_save", "Profile saved successfully");
            console.log(await saverep.json());


            loggedUserInfo.name = updates.fname + " " + updates.lname;
            localStorage.setItem("loggedUserInfo", JSON.stringify(loggedUserInfo));


            const ip = localStorage.getItem("ipaddress") || "N/A";
            const browserinfo = browserName + "-" + browserVersion + ".0.0";
            const flag = `Class Profile updated sucessfully (${loggedUserInfo.name})`;
            const gymid = loggedUserInfo.gymid || "";
            const username1 = loggedUserInfo.email || "";
            const Eventtype = username1;

            await trackButtonClick("ClassSettings", "Update_Staff", "staff", {});
            logEvent(
                { Eventtype, username1, ip, flag, browserinfo, gymid, isclass: true },
                gymid
            );

            // localStorage.setItem("loggedUserInfo", JSON.stringify(lObj));
            // logEvent(
            //     { Eventtype, username1, ip, flag, browserinfo, gymid },
            //     localStorage.getItem("loggedUserInfo")
            //         ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            //         : ""
            // );
            // localStorage.setItem("loggedUserInfo", JSON.stringify(lObj));
            // window.location.href = "/settingview";
            setBasicModal(false)
            setRefresh(true)
        } else {
            setError(errors);
        }
    }

    const [basicModal, setBasicModal] = useState(false);

    const toggleOpen = () => {
        setBasicModal(!basicModal);
    };
    const [basicActive, setBasicActive] = useState("tab1");

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const [centredModal, setCentredModal] = useState(false);
    const [centredModal2, setCentredModal2] = useState(false);

    const toggleOpenPlan = () => setCentredModal(!centredModal);
    const toggleOpenPlan2 = () => setCentredModal2(!centredModal2);


    const updateModules = (Plan) => {
        let modules = [];
        if (Plan !== null && Plan.plandetails) {
            if (Plan.plandetails.accountantrole) {
                modules.push("Accountant Role");
            }
            if (Plan.plandetails.smsintergration) {
                modules.push("SMS Integration");
            }
            if (Plan.plandetails.whatsappintegration) {
                modules.push("WhatsApp Integration");
            }
        }
        return modules.join(", ");
    };


    useEffect(() => {
        const popupRow = [];
        let snumber = 1;
        subPlans &&
            subPlans.length > 0 &&
            subPlans.forEach((item, index) => {
                const rarray = [];
                rarray.push(snumber++);
                // rarray.push(format(parseISO(item.createdAt), "yyyy-MM-dd"));
                rarray.push(formatDateTimeWithTZ(item.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", }));

                rarray.push(PlansData.find((obj) => obj._id === item.plandetails.id)?.name || "");
                rarray.push(
                    item.subscriptionfrequency && !item.plandetails.lifetimefree
                        ? `${item.subscriptionfrequency} months`
                        : "--"
                );
                rarray.push(
                    item.subscriptionstartdate
                        ? formatDateTimeWithTZ(item.subscriptionstartdate).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })
                        : "--"
                );
                rarray.push(
                    item.subscriptionexpirydate && !item.plandetails.lifetimefree
                        ? formatDateTimeWithTZ(item.subscriptionexpirydate).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", })
                        : "--"
                );
                rarray.push(item.amount && item.amount);
                popupRow.push(rarray);
            });

        setBasicData((prev) => ({ ...prev, rows: popupRow }));
    }, [subPlans, PlansData]);

    const downloaddata = (data, title) => {
        trackButtonClick("ClassSettings", "Subscription_Export", "staff", {});
        ExcelExportButton(data, title);
    };

    return (
        <>
            <SideNavClass activeTab={"classsettings"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >
                {isMobile && <>
                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>
                </>}

                <div className="">



                    <MDBTabs className="mb-3">
                        <MDBTabsItem>
                            <MDBTabsLink
                                onClick={() => handleBasicClick("tab1")}
                                active={basicActive === "tab1"}
                            >
                                Profile Settings
                            </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                            <MDBTabsLink
                                onClick={() => handleBasicClick("tab2")}
                                active={basicActive === "tab2"}
                            >
                                Subscription
                            </MDBTabsLink>
                        </MDBTabsItem>
                        {/* <MDBTabsItem>
                            <MDBTabsLink
                                onClick={() => handleBasicClick("tab3")}
                                active={basicActive === "tab3"}
                            >
                                Gyms
                            </MDBTabsLink>
                        </MDBTabsItem> */}



                    </MDBTabs>

                    <MDBTabsContent>
                        <MDBTabsPane open={basicActive === 'tab1'}>
                            <div className="w-100-mobile wp-50 border rounded-4 a p-4 pe-5 shadow-4">
                                <MDBCardTitle className="text-dark d-flex justify-content-between">
                                    <label>Profile Settings</label>
                                    <button
                                        className="edit-Btn"
                                        title="Edit"
                                        onClick={(e) => toggleOpen()}
                                    >
                                        <MDBIcon fas icon="pencil-alt" className="fs-6 me-2" /> Edit
                                    </button>
                                </MDBCardTitle>
                                <MDBCardText>
                                    <div className=" Business__Details__data  mt-2">
                                        <label>
                                            First Name:<span className="text-danger">*</span>
                                        </label>{" "}
                                        <label className="fw-600">{form.firstname}</label>
                                    </div>
                                    <div className=" Business__Details__data  mt-1">
                                        <label>
                                            Last Name:<span className="text-danger">*</span>
                                        </label>{" "}
                                        <label className="fw-600">{form.lastname}</label>
                                    </div>
                                    <div className=" Business__Details__data  mt-1">
                                        <label>Age:</label> <label className="fw-600">{form.age}</label>
                                    </div>
                                    <div className=" Business__Details__data  mt-1">
                                        <label>
                                            Gender:<span className="text-danger">*</span>
                                        </label>{" "}
                                        <label className="fw-600">{form.gender}</label>
                                    </div>
                                    <div className=" Business__Details__data  mt-1">
                                        <label>
                                            Mobile Number:<span className="text-danger">*</span>
                                        </label>{" "}
                                        <label className="fw-600">{form.number}</label>
                                    </div>
                                </MDBCardText>
                            </div>
                        </MDBTabsPane>
                        <MDBTabsPane open={basicActive === 'tab2'}>
                            <div className="wp-50 border rounded-4 a p-4 pe-5 shadow-4 w-100-mobile">
                                <MDBCardTitle className="text-dark d-flex justify-content-between">
                                    <label>Subscription</label>
                                    <div>

                                        <button
                                            className="edit-Btn ms-2"
                                            title="Edit"
                                            onClick={(e) => toggleOpenPlan()}
                                        >
                                            View History
                                        </button>
                                    </div>
                                </MDBCardTitle>
                                <MDBCardText>
                                    <div className="Business__Details__data mt-1">
                                        <label>Plan Name</label>
                                        <label className="fw-600">
                                            {PlansData.length > 0 && PlansData.find((obj) => obj._id == activeSubPlan?.planid)?.name || ""}
                                        </label>
                                    </div>
                                    <div className="Business__Details__data mt-1">
                                        <label>Status</label>
                                        <label className="fw-600">
                                            {activeSubPlan
                                                ? activeSubPlan.status == 1
                                                    ? "Active"
                                                    : activeSubPlan.status == 0
                                                        ? "Inactive"
                                                        : activeSubPlan.status == 2
                                                            ? "Pending"
                                                            : activeSubPlan.status == 3
                                                                ? "Canceled"
                                                                : "--"
                                                : ""}<div className="text-success ms-2">{activeSubPlan?.plandetails?.isfreetrail ? "Free Trail" : ""}</div>
                                        </label>
                                    </div>
                                    {/* <div className="Business__Details__data mt-1">
                                        <label>Additional Addons</label>
                                        <label className="fw-600">
                                            {updateModules(activeSubPlan)
                                                ? updateModules(activeSubPlan)
                                                : "--"}
                                        </label>
                                    </div> */}

                                    <div className="Business__Details__data mt-1">
                                        <label>Duration</label>
                                        <label className="fw-600">
                                            {subPlans.length > 0 && !subPlans[0]?.plandetails?.lifetimefree ? <>
                                                {activeSubPlan && activeSubPlan.subscriptionfrequency}{" "}
                                                {activeSubPlan && activeSubPlan.subscriptionfrequency == 1 ? "Month" : `Month(s)`}
                                            </> : "--"}
                                        </label>
                                    </div>
                                    <div className="Business__Details__data mt-1">
                                        <label>Start Date</label>
                                        <label className="fw-600">

                                            {activeSubPlan && activeSubPlan.subscriptionstartdate
                                                ? formatDate(activeSubPlan.subscriptionstartdate)
                                                : "--"}
                                        </label>
                                    </div>
                                    <div className="Business__Details__data mt-1">
                                        <label>End Date</label>
                                        <label className="fw-600">
                                            {subPlans.length > 0 && subPlans[0]?.subscriptionexpirydate && !subPlans[0]?.plandetails?.lifetimefree
                                                ? formatDate(subPlans[0].subscriptionexpirydate)
                                                : "--"}

                                        </label>
                                    </div>
                                </MDBCardText>
                            </div>
                        </MDBTabsPane>




                        {/* <MDBTabsPane open={basicActive === "tab3"}>
              <MDBRow>
                {mdata && mdata.length > 0 ? (
                  mdata.map((data, index) => (
                    <MDBCol md={3} lg={4} sm={12} className="mb-4">
                      <MDBCard className="gymsCardHeight">
                        <MDBCardBody>
                          <div key={index}
                            style={{ zIndex: "10" }}

                            onClick={() => handleCardClick(data)}
                          >
                            {index !== 0 && <div className="gym-delete"
                              onClick={(event) => {
                                event.stopPropagation();
                                setShowModel(true)
                                setSelectedGym(data)

                              }}
                            >
                              <MDBIcon fas icon="times" size="lg" />
                            </div>}

                            <div className="payment-span chip">
                              <label>Business Name:</label>{" "}
                              <label className="fw-600">{data.businessName}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Owner First Name:</label>{" "}
                              <label className="fw-600">{data.firstName || "N/A"}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Owner Last Name:</label>{" "}
                              <label className="fw-600">{data.lastName || "N/A"}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Email:</label>{" "}
                              <label className="fw-600">{data.businessEmail}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Contact No:</label>{" "}
                              <label className="fw-600">{data.contactNumber}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>City:</label>{" "}
                              <label className="fw-600">{data.city}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>State:</label>{" "}
                              <label className="fw-600">{data.state || "N/A"}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Country:</label>{" "}
                              <label className="fw-600">{data.country || "N/A"}</label>
                            </div>

                            <div className="payment-span chip">
                              <label>Business Address:</label>{" "}
                              <label className="fw-600">{data.address}</label>
                            </div>

                            <div className="mt-3">
                              <label className="m-0 fw-600">Business Logo:</label>
                              <div className="py-2">
                                <img
                                  alt="Business Logo"
                                  src={data.logourl || logo}
                                  style={{ maxWidth: "100%", maxHeight: "80px" }}
                                />
                              </div>
                            </div>
                          </div>

                        </MDBCardBody>
                      </MDBCard>
                    </MDBCol>
                  ))
                ) : (
                  <div
                    className="no-data-message d-flex justify-content-center align-items-center"
                    style={{ marginTop: '200px', height: '100%', width: '100%', paddingRight: '420px', }}
                  >
                    <p className="text-muted">No Data Found</p>
                  </div>
                )
                }
              </MDBRow>
            </MDBTabsPane> */}


                    </MDBTabsContent>
                    {smessage && (
                        <h4>
                            <Toast message={smessage} />
                        </h4>
                    )}
                    <MDBModal open={basicModal} setOpen={setBasicModal} tabIndex="-1" >
                        <MDBModalDialog>
                            {/* <form
              action="#"
              target="_blank"
              onSubmit={onSubmit}
              className="business-form w-100"
            > */}
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle>Edit Profile</MDBModalTitle>
                                    <MDBBtn
                                        className="btn-close"
                                        color="none"
                                        onClick={processCancel}
                                    ></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <div className="BusinessPage__content">
                                        <MDBCard className="shadow-0">
                                            <MDBCardBody className=" py-0">
                                                <MDBCardTitle></MDBCardTitle>
                                                <MDBCardText>
                                                    <MDBRow>
                                                        <div className=" Business__Details__data">
                                                            <label>
                                                                First Name:
                                                                <span className="text-danger">*</span>
                                                            </label>{" "}
                                                            <label className="fw-600">
                                                                <input
                                                                    className="Business__input__adjust"
                                                                    type="text"
                                                                    name="firstname"
                                                                    id="firs_name"
                                                                    placeholder="First Name"
                                                                    value={form.firstname}
                                                                    onChange={(e) =>
                                                                        updateForm({ firstname: e.target.value })
                                                                    }
                                                                />
                                                                {error.firstname && (
                                                                    <>
                                                                        <p className="clr-red">{error.firstname}</p>
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>
                                                        <div className=" Business__Details__data">
                                                            <label>
                                                                Last Name:<span className="text-danger">*</span>
                                                            </label>{" "}
                                                            <label className="fw-600">
                                                                <input
                                                                    className="Business__input__adjust"
                                                                    type="text"
                                                                    name="lastname"
                                                                    id="last_name"
                                                                    placeholder="Last Name"
                                                                    value={form.lastname}
                                                                    onChange={(e) =>
                                                                        updateForm({ lastname: e.target.value })
                                                                    }
                                                                />
                                                                {error.lastname && (
                                                                    <>
                                                                        <p className="clr-red">{error.lastname}</p>
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>
                                                        <div className=" Business__Details__data">
                                                            <label>Age:</label> <label className="fw-600">
                                                                <input
                                                                    className="Business__input__adjust"
                                                                    type="text"
                                                                    name="age"
                                                                    id="age"
                                                                    placeholder="Age"
                                                                    value={form.age}
                                                                    onChange={(e) =>
                                                                        updateForm({ age: e.target.value })
                                                                    }
                                                                />
                                                            </label>
                                                        </div>
                                                        <div className=" Business__Details__data">
                                                            <label>
                                                                Gender:<span className="text-danger">*</span>
                                                            </label>{" "}
                                                            <label className="fw-600">
                                                                <select
                                                                    className="Business__input__adjust"
                                                                    name="gender"
                                                                    id="time"
                                                                    value={form.gender}
                                                                    onChange={(e) =>
                                                                        updateForm({ gender: e.target.value })
                                                                    }
                                                                >
                                                                    <option value="Male">Male</option>
                                                                    <option value="Female">Female</option>
                                                                </select>
                                                            </label>
                                                        </div>

                                                        <div className=" Business__Details__data">
                                                            <label>
                                                                Mobile Number:
                                                                <span className="text-danger">*</span>
                                                            </label>{" "}
                                                            <label className="fw-600">
                                                                <input
                                                                    className="Business__input__adjust"
                                                                    type="text"
                                                                    name="contact                                                                                                                                                          s_name"
                                                                    // id="contact"
                                                                    placeholder="Number"
                                                                    value={form.number}
                                                                    onChange={(e) =>
                                                                        updateForm({ number: e.target.value })
                                                                    }
                                                                />
                                                                {error.number && (
                                                                    <>
                                                                        <p className="clr-red">{error.number}</p>
                                                                    </>
                                                                )}
                                                            </label>
                                                        </div>
                                                    </MDBRow>
                                                </MDBCardText>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </div>
                                </MDBModalBody>

                                <MDBModalFooter className="pe-3 pb-2">
                                    <MDBBtn color="secondary" onClick={processCancel}>
                                        cancel
                                    </MDBBtn>
                                    <MDBBtn onClick={onSubmit}>Save</MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                            {/* </form> */}
                        </MDBModalDialog>
                    </MDBModal>

                    <MDBModal
                        tabIndex="-1"
                        open={centredModal}
                        onClose={() => setCentredModal(false)}
                    >
                        <MDBModalDialog size="lg">
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle>Subscription History</MDBModalTitle>
                                    <MDBBtn
                                        className="btn-close"
                                        color="none"
                                        onClick={toggleOpenPlan}
                                    ></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <MDBDatatable entries={25} data={basicData} className="SuscriptionHistoryDataTable" />
                                </MDBModalBody>
                                <MDBModalFooter className="pe-3 pb-2">
                                    <MDBBtn color="secondary" onClick={toggleOpenPlan}>
                                        Close
                                    </MDBBtn>
                                    <MDBBtn
                                        className="ms-2"
                                        onClick={() => downloaddata(basicData, "subscriptionPlans")}
                                    >
                                        download
                                    </MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>


                    {/* <MDBModal
            tabIndex="-1"
            open={centredModal2}
            onClose={() => setCentredModal2(false)}
          >
            <MDBModalDialog>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Edit Class</MDBModalTitle>
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={toggleOpenPlan2}
                  ></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>


                  <div className="d-flex align-items-center mb-2">
                    <label className="mb-2">Class</label>
                    <div className="phoneselect">
                      <label className="m-0 ms-2 switch">
                        <input className="form-control" type="checkbox" checked={form.ontimerenewal} onChange={(e) => updateForm({ ontimerenewal: !form.ontimerenewal })} />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
               

                </MDBModalBody>
                <MDBModalFooter className="pe-3 pb-2">
                  <MDBBtn color="secondary" onClick={toggleOpenPlan2}>
                    Close
                  </MDBBtn>
                  <MDBBtn
                    className="ms-2"
                  >
                    download
                  </MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal> */}



                    {/* {showBusinessPop && (
                            <>
                                <Popup
                                    title="Add gym"
                                    ptype="modal-lg"
                                    content={
                                        <>
                                            <AddGym onSuccess={handleAddGymSuccess} />
                                        </>
                                    }
                                    handleClose={() => setShowBusinessPop(false)}
                                />
                            </>
                        )} */}




                    <MDBAlert
                        color={(Error2.includes("aggregation") || Error2.includes("try again.")) ? "danger" : (Error2.includes("successfully") || Error2.includes("successfully") ? "success" : "danger")}
                        autohide
                        position="top-center"
                        delay={5000}
                        appendToBody
                        open={Error2 !== ""}
                        onClose={() => setError2("")}
                    >
                        {Error2}
                    </MDBAlert>
                </div>

            </SideNavClass>
        </>
    );
};
export default ClassSettings;
